module.exports = __webpack_public_path__ + "static/media/Logo.49c050c7.png";